import React from 'react';
import getCardImage from './getCardImage.js';
import './Card.css';

function Card(card) {
  return (<img src={getCardImage(card.children)} className="CardImage" alt={card}/>);
}

export default Card;
